import { CloudUploadOutlined } from '@ant-design/icons'
import type { UploadProps } from 'antd'
import { RcFile } from 'antd/es/upload'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { useContext, useState } from 'react'
import UploadModal from '../Base/UploadModal'
import { validateJsonFileContent } from '../helper'
import { UploadJsonProps } from '../types'

const props: UploadProps = {
  name: 'file',
  accept: '.json',
  multiple: true,
  showUploadList: false,
  maxCount: 1,
};

export default function JsonUpload({
  title,
  subtitle = 'upload.select_json_file',
  icon = <CloudUploadOutlined />,
  onConfirm,
  onCancel,
  onFailedFileValidation,
}: UploadJsonProps) {
  const t = useContext(I18nContext)
  const [subtitleToShow, setSubtitleToShow] = useState<string>(t(subtitle))
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(true)

  const handleConfirm = (file?: RcFile) => {
    setConfirmButtonDisabled(true)
    setSubtitleToShow(t(subtitle))
    if (file) {
      onConfirm(file)
    }
  }

  const handleCancel = () => {
    setSubtitleToShow(t(subtitle))
    setConfirmButtonDisabled(true)
    if (onCancel) {
      onCancel()
    }
  }

  const onValidation = async (file: RcFile) => {
    if (file.type !== "application/json") {
      setSubtitleToShow(t(subtitle))
      setConfirmButtonDisabled(true)
      throw new Error();
    }
    const isFileValid = await validateJsonFileContent(file);
    setSubtitleToShow(isFileValid ? `${t('upload.selected_file')}: ${file.name}` : t('upload.invalid_json_content'));
    setConfirmButtonDisabled(!isFileValid);
    if(!isFileValid){
      throw new Error();
    }
  };

  return (
    <UploadModal
      validationCallback={onValidation}
      props={props}
      title={title}
      subtitle={subtitleToShow}
      confirmDisabled={confirmButtonDisabled}
      onConfirmCallback={handleConfirm}
      onCancelCallback={handleCancel}
      onFailedFileValidation={onFailedFileValidation}
      icon={icon}
    />
  )
}
